import type React from 'react';

import { Button, RouterProvider, TabList, Tabs } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';
import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { ShareLinks } from './components/ShareLinks';
import { usePageHeading } from './hooks/usePageHeading';

export const PageHeading: React.FC = () => {
	const {
		data: { tabItems, isGuide, showSapCta },
	} = usePageHeading();

	return (
		<>
			<div className="relative container mt-2 px-0">
				{/* RouterProvider overrides app-level SPA navigation so tab switches are full page loads.
				News and guides share the same path (/l/:country) and only differ by ?category=guides,
				so client-side navigation would show a loading indicator unnecessarily. */}
				<RouterProvider
					navigate={(href) => {
						window.location.assign(href);
					}}
				>
					<Tabs selectedKey={isGuide ? 'guides' : 'news'}>
						<TabList items={tabItems} />
					</Tabs>
				</RouterProvider>

				<div className="absolute top-1 right-8 z-10">
					{/* share links are using user agent, which is incompatible with SSR server-caching, so we need to render them on the client only */}
					<ClientRender>
						<ShareLinks />
					</ClientRender>
				</div>
			</div>
			{showSapCta && (
				<div className="sticky top-0 left-0 z-50 bg-white px-4 py-8 text-center">
					<Button
						as="a"
						variant="primary"
						className="w-full max-w-sm"
						href="/start-a-petition/intro?source_location=news_page"
						size="large"
						data-qa="start-a-petition-cta"
					>
						<Translate value="fe.components.header.start_a_petition" />
					</Button>
				</div>
			)}
		</>
	);
};
